export function getVerticalImageList() {
  return [
    { id: 0, src: "assets/images/indoor_white_2.webp", caption: "" },
    { id: 1, src: "assets/images/indoor_white_1.webp", caption: "" },
    { id: 2, src: "assets/images/indoor_red_2.webp", caption: "" },
  ];
}

export function getHorizontalImageList() {
  return [
    { id: 0, src: "assets/images/outdoor_korea_1.webp", caption: "" },
    { id: 1, src: "assets/images/outdoor_korea_2.webp", caption: "" },
    { id: 2, src: "assets/images/indoor_red_1.webp", caption: "" },
  ];
}
